import Enum from './enum'

class Votes extends Enum
{
  constructor(value) {
    super(value);
  }
}

Votes.init({
  EMPTY: 'None',
  DRAW: 'Draw',
  YES: 'Yes',
  NO: 'No'
}, {
  EMPTY: 'votes.empty',
  DRAW: 'votes.draw',
  YES: 'votes.yes',
  NO: 'votes.no'
});

export default Votes;
